export const Case = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9078)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 32C36 29.7909 37.7909 28 40 28H61C63.2091 28 65 29.7909 65 32V68C65 70.2091 63.2091 72 61 72H40C37.7909 72 36 70.2091 36 68V32ZM57.8023 42.8645C57.6704 42.7327 57.5141 42.6666 57.3335 42.6666C57.153 42.6666 56.9969 42.7327 56.8648 42.8645L55.5107 44.2084C54.7677 43.507 53.9168 42.9634 52.9586 42.5781C52.0004 42.1928 51.014 42.0001 50.0001 42.0001C48.0903 42.0001 46.4237 42.5782 45 43.7345C43.5763 44.8907 42.6388 46.3992 42.1874 48.2605V48.3333C42.1874 48.4236 42.2204 48.5018 42.2864 48.5677C42.3524 48.6337 42.4305 48.6666 42.5207 48.6666H44.5936C44.7465 48.6666 44.8506 48.5867 44.9062 48.4271C45.1978 47.7327 45.3818 47.3265 45.4582 47.2084C45.9443 46.4167 46.5901 45.7951 47.3957 45.3437C48.2014 44.8924 49.0694 44.6666 49.9999 44.6666C51.3959 44.6666 52.6077 45.1423 53.6355 46.0937L52.1978 47.5312C52.0662 47.6631 52 47.8195 52 48C52 48.1806 52.0661 48.3368 52.1978 48.4688C52.3299 48.6007 52.4862 48.6667 52.6668 48.6667H57.3335C57.5141 48.6667 57.6704 48.6007 57.8023 48.4688C57.9341 48.3368 58 48.1806 58 48V43.3333C58 43.1527 57.9345 42.9965 57.8023 42.8645ZM55.4062 51.3335H57.4062C57.4966 51.3335 57.5748 51.3666 57.6408 51.4322C57.7068 51.4985 57.7399 51.5763 57.7399 51.6667C57.7399 51.7013 57.7366 51.7257 57.7296 51.7395C57.285 53.6006 56.3544 55.1094 54.9378 56.2656C53.5211 57.4218 51.8614 57.9999 49.9585 57.9999C48.9447 57.9999 47.9638 57.8091 47.0158 57.427C46.0679 57.0451 45.2223 56.4998 44.4792 55.7916L43.1355 57.1355C43.0035 57.2673 42.8473 57.3336 42.6668 57.3336C42.4862 57.3336 42.3299 57.2672 42.1979 57.1355C42.0659 57.0036 42 56.8472 42 56.6668V52C42 51.8195 42.0659 51.663 42.1979 51.5312C42.3298 51.3992 42.4861 51.3331 42.6667 51.3331H47.3335C47.5141 51.3331 47.6703 51.3992 47.8022 51.5312C47.9341 51.663 48.0001 51.8194 48.0001 52C48.0001 52.1804 47.9341 52.3369 47.8022 52.4687L46.3751 53.8957C46.8681 54.3541 47.4272 54.7083 48.0522 54.9586C48.6771 55.2085 49.3265 55.3334 50.0001 55.3334C50.9306 55.3334 51.7986 55.1079 52.6043 54.6563C53.4097 54.205 54.0556 53.5832 54.5418 52.7917C54.6181 52.6736 54.8023 52.2675 55.0938 51.5731C55.1492 51.4133 55.2534 51.3335 55.4062 51.3335Z"
        fill="#262626"
      />
      <defs>
        <filter
          id="filter0_b_2954_9078"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9078"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9078"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
